import styled, { css } from 'styled-components';
import { colors, remCalc } from '@prisjakt/ui-base';
import { Size } from './types';

const lineHeight = (size?: Size) => {
  switch (size) {
    case 'tiny':
      return 12;
    case 'small':
      return 16;
    default:
      return 18;
  }
};

type PropertyListProps = {
  size?: Size;
  maxRows?: number;
  toneDown?: boolean;
  showAsList?: boolean;
};

export const PropertyList = styled.ul<PropertyListProps>`
  line-height: ${props => remCalc(lineHeight(props.size))};
  max-height: ${props =>
    props.maxRows
      ? remCalc(props.maxRows * lineHeight(props.size) - 1)
      : 'none'};
  overflow: ${props => (props.maxRows ? 'hidden' : 'visible')};
  color: ${props =>
    props.toneDown ? props.theme.text.secondary : props.theme.text.primary};
  padding-left: ${props => (props.showAsList ? remCalc(16) : 0)};
`;

type PropertyProps = {
  showAsList?: boolean;
  truncate?: boolean;
};
export const Property = styled.li<PropertyProps>`
  display: ${props => (props.showAsList ? 'list-item' : 'inline-block')};
  padding: 0 ${props => (props.showAsList ? remCalc(2) : 0)};

  &:not(:last-of-type)::after {
    content: '${props => (props.showAsList ? '' : ',')}';
  }

  ${props =>
    props.truncate &&
    css`
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    `}

  ${props =>
    props.showAsList &&
    props.truncate &&
    css`
      list-style-position: inside;
    `}
`;

const placeholderHeight = (size: Size) => {
  switch (size) {
    case 'tiny':
      return 14;
    case 'small':
      return 18;
    default:
      return 21;
  }
};

type PlaceHolderPropertyProps = {
  toneDown?: boolean;
  size: Size;
};
export const PlaceholderProperty = styled.li<PlaceHolderPropertyProps>`
  background: ${props =>
    props.toneDown ? colors.semiWhite : colors.lightGray1};
  height: ${props => remCalc(placeholderHeight(props.size))};
  width: 200px;
  border-radius: 3px;
`;
